import {
  AddWorkingHoursDailyConfig,
  AddWorkingHoursDailyConfigs,
  AdministrationResultStatus,
  ScheduleData,
  TermData,
  UpdateConfigurationData,
  WorkingHoursDailyConfigData,
} from '../../clients/system-api/SystemApiClient';
import { ConfigurationParameterService } from '../../services/configuration-parameter.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  AddConfigurationData,
  ConfigurationParameterData,
} from 'src/app/clients/system-api/SystemApiClient';
import { TranslateService } from '@ngx-translate/core';
import {
  WindowDimensions,
  WindowDimensionsService,
} from 'src/app/services/window-dimension-service.service';
import * as moment from 'moment';
import { TermService } from 'src/app/services/term.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import { GenericModalComponent } from 'src/app/components/modals/generic-modal/generic-modal.component';

@Component({
  selector: 'app-configuration-page',
  templateUrl: './configuration-page.component.html',
  styleUrls: ['./configuration-page.component.scss'],
})
export class ConfigurationPageComponent implements OnInit {
  activeConfigurationParameter: any;
  configData?: AddConfigurationData;
  currentConfigurationData?: ConfigurationParameterData;
  addConfigurationData: AddConfigurationData = new AddConfigurationData();
  dailyConfig: WorkingHoursDailyConfigData = new WorkingHoursDailyConfigData();
  workingHours: AddWorkingHoursDailyConfigs = new AddWorkingHoursDailyConfigs();
  hasConfiguration: boolean = false;

  sortedWorkingHours: WorkingHoursDailyConfigData[][] = [];
  originalWorkingHourConfigs?: WorkingHoursDailyConfigData[];

  editWorkingHoursPopupState: boolean = false;

  windowDimensions: WindowDimensions = {} as WindowDimensions;

  editingWorkingHours: Map<number, WorkingHoursDailyConfigData> = new Map<
    number,
    WorkingHoursDailyConfigData
  >();

  hasEditedHours: boolean = false;
  negatedTermsToCancel?: TermData[] = [];
  hasBookedTermsInChange: boolean = false;
  negatedSchedules: ScheduleData[] = [];  

  isEditTimeBetweenGeneratedTermsOpen: boolean = false;
  isEditPauseTimeAfterTermsInMinutes: boolean = false;
  timeAfterTermsInMinutes: AddConfigurationData = new AddConfigurationData();
  @ViewChild(GenericModalComponent) genericModalComponent!: GenericModalComponent;

  constructor(
    private _windowDimensionService: WindowDimensionsService,
    private translateService: TranslateService,
    private configurationParameterService: ConfigurationParameterService,
    private termService: TermService,
    private scheduleService: ScheduleService
  ) {
    this._windowDimensionService
      .getWindowDimensions$()
      .subscribe((dimensions) => {
        this.windowDimensions = dimensions;
      });
  }

  ngOnInit(): void {
    this.configData = new AddConfigurationData();
    this.retrieveActiveConfigurationParameter();
  }

  public async retrieveActiveConfigurationParameter(): Promise<void> {
    await new Promise<void>((resolve) => {
      this.configurationParameterService
        .retrieveActiveConfigurationParameter()
        .subscribe((data) => {
          if (data.status === AdministrationResultStatus.Success) {
            this.currentConfigurationData = data.content;
            if( this.currentConfigurationData?.workingHours && this.currentConfigurationData?.workingHours.length > 0){
              this.originalWorkingHourConfigs = this.currentConfigurationData?.workingHours!;
              this.groupWorkingHourConfigs();
            }

            if (!this.hasConfiguration) {
              this.hasConfiguration = true;
            }
            resolve();
          } else {
            this.hasConfiguration = false;
            resolve();
          }
        });
    });
  }

  public groupWorkingHourConfigs() {
    if (
      this.currentConfigurationData &&
      this.currentConfigurationData.workingHours
    ) {
      this.sortedWorkingHours = [];
      this.currentConfigurationData.workingHours =
        this.currentConfigurationData.workingHours.filter(
          (config) => config.working == true
        );
      const currentWorkingHours = this.currentConfigurationData.workingHours;

      let sortedWorkingHoursGroup: WorkingHoursDailyConfigData[] = [currentWorkingHours[0]];

      if (currentWorkingHours.length > 1) {
        for (let i = 1; i < currentWorkingHours.length; i++) {
          let currentWorkingHour = sortedWorkingHoursGroup[sortedWorkingHoursGroup.length - 1];
          let comparingWorkingHour = currentWorkingHours[i];

          if(comparingWorkingHour && currentWorkingHour && currentWorkingHour.dayOfWeek && comparingWorkingHour.dayOfWeek) {
            if (Math.abs(currentWorkingHour.dayOfWeek - comparingWorkingHour.dayOfWeek) === 1 &&
              currentWorkingHour.fromTime?.getUTCHours() === comparingWorkingHour.fromTime?.getUTCHours() 
              && currentWorkingHour.fromTime?.getUTCMinutes() === comparingWorkingHour.fromTime?.getUTCMinutes() 
              && currentWorkingHour.toTime?.getUTCHours() === comparingWorkingHour.toTime?.getUTCHours() 
              && currentWorkingHour.toTime?.getUTCMinutes() === comparingWorkingHour.toTime?.getUTCMinutes()) {
              sortedWorkingHoursGroup.push(comparingWorkingHour);
            } else {
              this.sortedWorkingHours.push(sortedWorkingHoursGroup);
              sortedWorkingHoursGroup = [comparingWorkingHour];
            }
          }
        }
      }

      this.sortedWorkingHours.push(sortedWorkingHoursGroup);
    }
  }

  public async addConfiguration(): Promise<void> {
    if (!this.hasConfiguration) {
      await new Promise<void>((resolve) => {
        this.configurationParameterService
          .addConfiguration(this.addConfigurationData)
          .subscribe((result) => {
            if (result === AdministrationResultStatus.Success) {
              resolve();
            } else {
              resolve();
            }
          });
      });
    }
  }

  public async updateConfiguration(updateConfigurationData: UpdateConfigurationData): Promise<void> {
    if (this.hasConfiguration) {
      await new Promise<void>((resolve) => {
        this.configurationParameterService
          .updateConfiguration(updateConfigurationData)
          .subscribe((result) => {
            if (result === AdministrationResultStatus.Success) {
              resolve();
            } else {
              resolve();
            }
          });
      });
    }
  }

  public editTimeBetweenGeneratedTermsInMinutes(value?: string) {
    this.isEditTimeBetweenGeneratedTermsOpen = !this.isEditTimeBetweenGeneratedTermsOpen;
    if(!this.isEditTimeBetweenGeneratedTermsOpen) {
      this.saveTimeBetweenGeneratedTermsInMinutes(value ?? '0');
    }
  }

  public saveTimeBetweenGeneratedTermsInMinutes(value: string) {
    if (this.currentConfigurationData) {
      this.currentConfigurationData.timeBetweenGeneratedTermsInMinutes = !isNaN(Number(value)) ? Number(value) : 0;
      this.isEditTimeBetweenGeneratedTermsOpen = false;

      let updateConfigurationData = new UpdateConfigurationData();
      updateConfigurationData.id = this.currentConfigurationData.id;
      updateConfigurationData.timeBetweenGeneratedTermsInMinutes = this.currentConfigurationData.timeBetweenGeneratedTermsInMinutes;
      this.updateConfiguration(updateConfigurationData);
    }
  }

  public savePauseTimeAfterTermsInMinutes(value: string) {
    if (this.currentConfigurationData) {
      this.currentConfigurationData.pauseTimeAfterTermsInMinutes = !isNaN(Number(value)) ? Number(value) : 0;
      this.isEditPauseTimeAfterTermsInMinutes = false;

      let updateConfigurationData = new UpdateConfigurationData();
      updateConfigurationData.id = this.currentConfigurationData.id;
      updateConfigurationData.pauseTimeAfterTermsInMinutes = this.currentConfigurationData.pauseTimeAfterTermsInMinutes;
      this.updateConfiguration(updateConfigurationData);
    }
  }

  public editPauseTimeAfterTermsInMinutes(value?: string) {
    this.isEditPauseTimeAfterTermsInMinutes = !this.isEditPauseTimeAfterTermsInMinutes;
    if(!this.isEditPauseTimeAfterTermsInMinutes) {
      this.savePauseTimeAfterTermsInMinutes(value ?? '0');
    }
  }

  public async updateWorkingHoursDailyConfig(): Promise<void> {
    await new Promise<void>((resolve) => {
      this.configurationParameterService
        .updateWorkingHoursDailyConfig(this.dailyConfig)
        .subscribe((result) => {
          if (result === AdministrationResultStatus.Success) {
            resolve();
          } else {
            resolve();
          }
        });
    });
  }

  public async updateAllWorkingHoursDailyConfigs(): Promise<void> {
    await new Promise<void>((resolve) => {
      this.configurationParameterService
        .updateAllWorkingHoursDailyConfigs(this.workingHours)
        .subscribe((result) => {
          if (result === AdministrationResultStatus.Success) {
            resolve();
          } else {
            resolve();
          }
        });
    });
  }

  public translate(key: string) {
    return this.translateService.instant(key);
  }

  public toggleEditWorkingHoursPopup(state?: boolean) {
    this.editWorkingHoursPopupState = state ?? !this.editWorkingHoursPopupState;
    if(this.editWorkingHoursPopupState){
      this.hasEditedHours = false;
    } else {
      if(this.genericModalComponent){ this.genericModalComponent.handleClose(); }
    }
  }

  public updateFromTimeEditList(
    value: string,
    workingHourConfig: WorkingHoursDailyConfigData
  ) {
    if (workingHourConfig.working) {
      if (!this.hasEditedHours) {
        this.hasEditedHours = true;
      }
      workingHourConfig.fromTime?.setHours(parseInt(value.split(':')[0]));
      workingHourConfig.fromTime?.setMinutes(parseInt(value.split(':')[1]));

      if (
        workingHourConfig &&
        workingHourConfig.toTime &&
        workingHourConfig.fromTime
      ) {
        if (workingHourConfig.fromTime > workingHourConfig.toTime) {
          let originalMinutes = workingHourConfig.toTime.getMinutes();
          workingHourConfig.toTime = new Date(workingHourConfig.fromTime);
          workingHourConfig.toTime.setHours(
            workingHourConfig.toTime.getHours() + 1
          );
          workingHourConfig.toTime.setMinutes(originalMinutes);
        }
      }

      this.editingWorkingHours.set(
        workingHourConfig.dayOfWeek ?? 0,
        workingHourConfig
      );
    }
  }

  public updateToTimeEditList(
    value: string,
    workingHourConfig: WorkingHoursDailyConfigData
  ) {
    if (workingHourConfig.working) {
      if (!this.hasEditedHours) {
        this.hasEditedHours = true;
      }
      workingHourConfig.toTime?.setHours(parseInt(value.split(':')[0]));
      workingHourConfig.toTime?.setMinutes(parseInt(value.split(':')[1]));

      if (
        workingHourConfig &&
        workingHourConfig.toTime &&
        workingHourConfig.fromTime
      ) {
        if (workingHourConfig.toTime < workingHourConfig.fromTime) {
          let originalMinutes = workingHourConfig.fromTime.getMinutes();
          workingHourConfig.fromTime = new Date(workingHourConfig.toTime);
          workingHourConfig.fromTime.setHours(
            workingHourConfig.fromTime.getHours() - 1
          );
          workingHourConfig.fromTime.setMinutes(originalMinutes);
        }
      }

      this.editingWorkingHours.set(
        workingHourConfig.dayOfWeek ?? 0,
        workingHourConfig
      );
    }
  }

  public async prepareSaveWorkingHours(): Promise<void>{
    this.workingHours = new AddWorkingHoursDailyConfigs();

    for (let i = 1; i <= 7; i++) {
      let value =
        this.editingWorkingHours.get(i) ??
        this.originalWorkingHourConfigs?.find(
          (config) => config.dayOfWeek === i
        ) ??
        new WorkingHoursDailyConfigData();

      let workingHourConfig = new AddWorkingHoursDailyConfig();
      workingHourConfig.fromTime = moment(value.fromTime).utc(true).toDate();
      workingHourConfig.toTime = moment(value.toTime).utc(true).toDate();
      workingHourConfig.working = value.working;

      switch (i) {
        case 1: this.workingHours.mondayWorkingHours = workingHourConfig; break;
        case 2: this.workingHours.tuesdayWorkingHours = workingHourConfig; break;
        case 3: this.workingHours.wednesdayWorkingHours = workingHourConfig; break;
        case 4: this.workingHours.thursdayWorkingHours = workingHourConfig; break;
        case 5: this.workingHours.fridayWorkingHours = workingHourConfig; break;
        case 6: this.workingHours.saturdayWorkingHours = workingHourConfig; break;
        case 7: this.workingHours.sundayWorkingHours = workingHourConfig; break;
      }

      let editCurrentConfigList =
        this.currentConfigurationData?.workingHours?.find(
          (config) => config.dayOfWeek === i
        );
      let editOriginalConfigList = this.originalWorkingHourConfigs?.find(
        (config) => config.dayOfWeek === i
      );

      if (editCurrentConfigList) {
        editCurrentConfigList.fromTime = value.fromTime;
        editCurrentConfigList.toTime = value.toTime;
        editCurrentConfigList.working = value.working;
      }

      if (editOriginalConfigList) {
        editOriginalConfigList.fromTime = value.fromTime;
        editOriginalConfigList.toTime = value.toTime;
        editOriginalConfigList.working = value.working;
      }
    }

    this.termService.retrieveNegatedTermsByWorkingHoursDailyConfigs(this.workingHours);
    
    await this.negatedSchedulesUpdate(this.workingHours).then((result) => {
      this.negatedSchedules = result;
    });

    await new Promise<void>((resolve) => {
      this.termService
        .retrieveNegatedTermsByWorkingHoursDailyConfigs(this.workingHours)
        .subscribe((result) => {
          if (result.status === AdministrationResultStatus.Success) {
            if(result.content?.length !== 0){
              this.hasBookedTermsInChange = true;
              this.negatedTermsToCancel = result.content;
            } else { this.saveWorkingHours(); }
            resolve();
          } else {
            this.saveWorkingHours();
            resolve();
          }
        });
    });
  }

  public async saveWorkingHours(): Promise<void> {
    if(this.negatedSchedules.length > 0 ){
      //TO-DO: Open popup to show negated schedules      
    }

    this.hasBookedTermsInChange = false; 
    this.negatedTermsToCancel = [];
    this.negatedSchedules = [];

    this.updateAllWorkingHoursDailyConfigs();
    this.groupWorkingHourConfigs();
    this.toggleEditWorkingHoursPopup(false);
  }

  public async saveWorkingHoursAndCancel(): Promise<void> {
    if (this.negatedTermsToCancel && this.negatedTermsToCancel.length > 0) {
    
      for (const term of this.negatedTermsToCancel) {
        if(term.id){ await this.cancelTerm(term.id); }
      }
    }

    this.saveWorkingHours();
  }

  private async cancelTerm(termId: number): Promise<void> {
    return new Promise<void>((resolve) => {
      const sub = this.termService.cancelTerm(termId).subscribe((data) => {
        if (data === AdministrationResultStatus.Success) {
          resolve();
        } else {
          resolve();
        }
      });
      sub.add(() => sub.unsubscribe());
    });
  }

  private async negatedSchedulesUpdate(workingHours: AddWorkingHoursDailyConfigs): Promise<ScheduleData[]> {
    return new Promise<ScheduleData[]>((resolve) => {
      const sub = this.scheduleService.updateNegatedSchedulesByWorkingHoursDailyConfigsChange(workingHours).subscribe((data) => {
        if (data.status === AdministrationResultStatus.Success) {
          if(data.content && data.content.length > 0){
            resolve(data.content);
          } else resolve([]);
        } else {
          resolve([]);
        }
      });
      sub.add(() => sub.unsubscribe());
    });
  }
}
